import * as z from 'zod'

export const filterTypeEnum = z.union([
  z.literal('is'),
  z.literal('is-not'),
  z.literal('contains'),
  z.literal('does-not-contain'),
  z.literal('starts-with'),
  z.literal('ends-with'),
  z.literal('is-empty'),
  z.literal('is-not-empty'),
  z.literal('greater-than'),
  z.literal('lower-than'),
])

export type FilterType = z.infer<typeof filterTypeEnum>

// Base filter schema for simple filters
const baseFilterSchema = z.object({
  type: filterTypeEnum,
  by: z.string(), // column id
  value: z.string(),
})

// Define the recursive filter type with proper discrimination
export type BaseFilter = z.infer<typeof baseFilterSchema>
export type AndFilter = {
  type: 'and'
  filters: Filter[]
}
export type OrFilter = {
  type: 'or'
  filters: Filter[]
}
export type Filter = BaseFilter | AndFilter | OrFilter

// Create the recursive schema using lazy evaluation
const filterSchema: z.ZodType<Filter> = z.lazy(() =>
  z.union([
    baseFilterSchema,
    z.object({
      type: z.literal('and'),
      filters: z.array(filterSchema),
    }),
    z.object({
      type: z.literal('or'),
      filters: z.array(filterSchema),
    }),
  ])
)

// Export the main schema for list filters
export const filtersSchema = z.array(filterSchema)
export type Filters = z.infer<typeof filtersSchema>

export const sortDirections = ['asc', 'desc'] as const
export const sortDirectionsEnum = z.enum(sortDirections)

export type SortDirection = z.infer<typeof sortDirectionsEnum>

export const sortSchema = z.object({
  type: sortDirectionsEnum,
  by: z.string(), // column id
})
export type Sort = z.infer<typeof sortSchema>

const example: Filters = [{ type: 'and', filters: [] }]

example.forEach((filter) => {
  if (filter.type === 'and') {
    filter.filters
  } else if (filter.type === 'or') {
    filter.filters
  } else {
    filter.by
  }
})
